import { HasType } from "../agent.card";
import { Message } from "@me8eon/messages";

import { ContextAndMessagesAndSelected, SelectorFn } from "./selectorFn";
import { ErrorsOr, LogAnd } from "@me8eon/errors";


export type ChainSelector<Selector> = {
    type: 'chain'
    chain: Selector[]
    description?: string
}


export function chainSelector<Context, Selector extends HasType>(): SelectorFn<Context, ChainSelector<Selector>> {
    return {
        isDefinedAt: (selector, context, messages, sc) =>
            selector.chain.some(sel => {
                const selFn = sc.selFns[sel.type];
                return selFn && (!selFn.isDefinedAt || selFn.isDefinedAt(sel, context, messages, sc));
            }),
        execute: async (selector: ChainSelector<Selector>, context: Context, messages: Message[], sc): Promise<LogAnd<ErrorsOr<ContextAndMessagesAndSelected<Context>>>> => {
            for (const sel of selector.chain) {
                const type = sel.type;
                const selFn = sc.selFns[type];
                if (!selFn) return {
                    errors: [`Selector ${type} not found in chain. Legal values are ${Object.keys(selector.chain).join(', ')}`],
                    log: {whatHappened: 'chain.selector.notFound', severity: 'error'}
                }
                if (!selFn.isDefinedAt || selFn.isDefinedAt(selector, context, messages, sc))
                    return selFn.execute(sel, context, messages, sc);
            }
            return {
                errors: [`No selector matched in chain: ${selector.chain.map(s => s.type).join(', ')}`],
                log: {whatHappened: 'chain.selector.noMatch', severity: 'error'}
            }
        }
    }
}
